<div class="modal"
     cdkTrapFocus>
  <i class="fal fa-times modal__close"
     (click)="close()"></i>
  <h2> New Assessment</h2>
  <ng-container *ngIf="!assessmentSaved">
    <app-entity-assessment-add [campaignId]="data.campaignId"
                               [entityId]="data.entityId"
                               [entityTypeId]="data.entityTypeId"
                               (saved)="onAssessmentSaved($event)"></app-entity-assessment-add>
  </ng-container>
  <ng-container *ngIf="assessmentSaved">
    <app-success-notification [messages]="'Assessment Saved'"></app-success-notification>

    <div class="vert-0050">
      <h2 class="mt-0200 mb-0025">Add Note <span class="h5">(optional)</span></h2>

      <app-create-note [targetId]="data.entityId"
                       [shouldAutofocusInput]="true"
                       [targetType]="'Entity'"
                       (noteAdded)="close(null)"></app-create-note>
    </div>
  </ng-container>

</div>
